import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FieldWrapper from './FieldWrapper';
import SvgLoader from '../media/MediaSvgLoader';
import suitcss from '../../../helpers/suitcss';
import connectUniqueId from '../service/UniqueIdConnector';
import { inputShape } from '../../../propTypes/field';

const componentName = 'FieldPassword';
const FieldPassword = (props) => {
  const {
    uniqueId, label, input, ui,
  } = props;
  const [passwordVisible, setPasswordVisible] = useState(false);
  const passwordVisibilityKeyWord = passwordVisible ? 'hidden' : 'shown';
  const passwordIcon = `/icons/icon-visibility-${passwordVisibilityKeyWord}-neutral.svg`;

  return (
    <FieldWrapper
      componentName={componentName}
      {...props}
    >
      {wrapperProvider => (
        <label htmlFor={uniqueId}>
          <span>
            {label}
            {!wrapperProvider.isRequired && wrapperProvider.getIsOptionalElement()}
          </span>
          <div
            className={suitcss({
              componentName,
              descendantName: 'iconWrapper',
            })}
          >
            <input
              id={uniqueId}
              type={passwordVisible ? 'text' : 'password'}
              {...input}
            />
            <button
              type="button"
              onClick={() => setPasswordVisible(!passwordVisible)}
              className={suitcss({
                componentName,
                descendantName: 'visibilityIcon',
              })}
              aria-label={
                passwordVisible
                ? ui?.guiWordPasswordInvisibleAlttext
                : ui?.guiWordPasswordVisibleAlttext
              }
            >
              <SvgLoader path={passwordIcon} />
            </button>
          </div>
        </label>
      )}
    </FieldWrapper>
  );
};

FieldPassword.propTypes = {
  uniqueId: PropTypes.string.isRequired,
  label: PropTypes.string,
  input: inputShape,
  ui: {
    guiWordPasswordInvisibleAlttext: PropTypes.string,
    guiWordPasswordVisibleAlttext: PropTypes.string,
  },
};

export default connectUniqueId('fp')(FieldPassword);
